import { useState } from 'react';
import { HelpCircle, ChevronUp } from 'lucide-react';

export const IconLegend = ({ items, className = '' }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={className} data-testid="icon-legend">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        data-testid="icon-legend-toggle"
        className="flex items-center gap-1.5 text-[11px] font-semibold text-slate-400 hover:text-[#C5A059] transition-colors"
      >
        {open ? <ChevronUp className="w-3.5 h-3.5" /> : <HelpCircle className="w-3.5 h-3.5" />}
        {open ? 'Ocultar legenda' : 'O que significa cada ícone?'}
      </button>
      {open && (
        <div className="mt-2 p-3 bg-slate-50 rounded-xl border border-slate-100 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-2" data-testid="icon-legend-items">
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-2">
              <span className={`p-1.5 rounded-lg flex-shrink-0 inline-flex ${it.cls || 'bg-slate-100 text-slate-500'}`}>{it.icon}</span>
              <span className="text-[11px] text-slate-600 leading-tight">{it.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
